import { createRoot } from 'react-dom/client';
import App from './App';
import './global.css';
import { registerSW } from 'virtual:pwa-register';

// Register service worker
registerSW({ immediate: true });

startApp();

function startApp() {
  const container = document.getElementById("root");
  if (!container) {
    throw new Error("Root container missing in index.html");
  }

  createRoot(container).render(<App />);
}